import React from "react";
import FadeInSection from "./FadeInSection"; // Import animation wrapper
import "./DataAPIOperatorAgent.css"; // Import the CSS file

import DataAPIOperatorAgentInstructions from "./DataAPIOperatorAgentInstructions";
import DataAPIOperatorAgentChat from "./DataAPIOperatorAgentChat";

const DataAPIOperatorAgent = () => {
  return (
    <FadeInSection className="data-api-operator-container">

      <img
        src={`${process.env.PUBLIC_URL}/data_operator.svg`} 
        alt="Data Operator" 
        className="agent-image"
      />

      <h2 className="data-api-operator-title">Data Operator Agent</h2>

      <p className="data-api-operator-description">
        {/* Seamlessly connects LLMs to real-time, large-scale databases, automating data retrieval and ensuring high-fidelity context for AI-driven tasks. */}
        Before building AI agents within a Retrieval-Augmented Generation (RAG) process, it's essential to ensure the retrieval of high-quality information for user prompts. Without this, your agents won't perform effectively. 
      </p>
      <p className="data-api-operator-description">
        Our agent <strong>removes this barrier</strong> by serving as a data operator, seamlessly determining what information from real-time, large-scale database APIs, consistutes high-fidelity context for other AI Agents.
      </p>

      <div className="data-api-operator-grid">

        {/* Benefit 2 */}
        <div className="data-api-operator-item">
          <h3 className="data-api-operator-subtitle">Keep Your Data Pipeline</h3>
          <p className="data-api-operator-text">
            Your API data is already organized and queryable—no changes are required to integrate our agent.
          </p>
        </div>


        {/* Benefit 1 */}
        <div className="data-api-operator-item">
          <h3 className="data-api-operator-subtitle">Smart API Interaction</h3>
          <p className="data-api-operator-text">
            Leverages schema-aware operations to efficiently retrieve the right data, eliminating unnecessary API calls and avoiding brute-force vector searches.
          </p>
        </div>


        {/* Benefit 3 */}
        <div className="data-api-operator-item">
          <h3 className="data-api-operator-subtitle">Private and Secure</h3>
          <p className="data-api-operator-text">
            Our agent ensures that raw data is never pulled during decision-making. Your data remains securely within your environment at all times.
          </p>
        </div>
      </div>

      {/* <div className="data-api-operator-example">
        <h3 className="data-api-operator-example-title">Example Use Case</h3>
        <p className="data-api-operator-example-text">
          <strong>Automated Data Retrieval</strong> – The agent efficiently queries APIs based on natural language prompts, integrating structured, real-time data into AI-generated responses.
        </p>
        <p className="data-api-operator-example-text">
          NOTE: Sections below should include example schema, other user inputs, and talk to API (talk to wikipedia API) interface.
        </p>
      </div> */}
      <DataAPIOperatorAgentChat />
      <DataAPIOperatorAgentInstructions />

    </FadeInSection>
  );
};

export default DataAPIOperatorAgent;
